<template>
  <div class="checkboxContainer h-20 flex bg-white border border-black">
    <div class="w-16 border-r justify-center items-center hidden xl:flex py-4">
      <div class="w-5/12">
        <zt-check-box
          data-vs-checkbox="select-all"
          v-model="value"
          fill
          :indeterminate="isIndeterminate"
          :key="keyCheckbox"
          @change="changeSelectAll"
        />
      </div>
    </div>
    <div class="w-full" :class="this.selectedItems > 0 ? 'bg-multiple-selection':''">
      <div class="flex flex-wrap h-full" >
        <template v-if="this.selectedItems > 0">
          <div class="px-4 flex items-center w-full">
            <div class="w-1/2">
              <span class="font-normal items-selected">
                <template v-if="selectedItems < 2">
                  {{ $t("message.uploadImageComponent.body.leftContainer.multipleSelection.oneSelectedItem") }}
                </template>
                <template v-else>
                  {{ $t("message.uploadImageComponent.body.leftContainer.multipleSelection.xSelectedItems", {quantity: selectedItems}) }}
                </template>
              </span>
            </div>
            <div v-if="visibleItems !== totalItems" class="w-3/5">
              <span
                class="font-medium text-zt-md select-all-btn cursor-pointer"
                @click="selectAll"
                data-vs-button="select-total-all"
              >
                {{ $t("message.uploadImageComponent.body.leftContainer.multipleSelection.selectAll", {total: totalItems}) }}
              </span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="px-4 flex items-center justify-between w-full">
            <div>
              <button @click="changeAscDesc" data-vs-button="order-by">
                <zt-icon :name="asc ? 'arrow-up' : 'arrow-down'" />
                <span class="font-normal items-selected">
                  {{ asc ? $t("message.uploadImageComponent.body.leftContainer.filter.asc") : $t("message.uploadImageComponent.body.leftContainer.filter.desc") }}
                </span>
              </button>
            </div>
            <div class="text-right flex items-center text-base">
              <div class="mr-3">
                <span>{{ $t("message.uploadImageComponent.body.leftContainer.filter.SelectOption") }}</span>
              </div>
              <div class="mx-1">
                <zt-dropdown
                  data-vs-dropdown=""
                  gtmClass="zt-gtm-documents-inbox-order-by"
                  ref="ztDropdownOrder"
                  label=""
                  v-slot="{ itemSelected }"
                  v-model="orderBy"
                  @input="changeOrderBy"
                  outlined
                  rounded='rounded'
                  :default-value="initValue"
                  size-adjustable
                >
                  <zt-dropdown-item
                    v-for="(item, index) in orderTypes"
                    :key="index"
                    :item="item"
                    :item-selected="itemSelected"
                  />
                </zt-dropdown>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isEqual } from 'lodash';

export default {
  props: {
    selectedItems: {
      type: Number,
      default: 0
    },
    visibleItems: {
      type: Number,
      default: 0
    },
    totalItems: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      value: false,
      keyCheckbox: 0,
      asc: false,
      orderTypes: [
        {
          text: this.$t("message.uploadImageComponent.body.leftContainer.filter.date"),
          value: 'creation_date'
        },
        {
          text: this.$t("message.uploadImageComponent.body.leftContainer.filter.sector"),
          value: 'sector'
        },
        {
          text: this.$t("message.uploadImageComponent.body.leftContainer.filter.locacion"),
          value: 'location'
        },
        {
          text: this.$t("message.uploadImageComponent.body.leftContainer.filter.name"),
          value: 'name'
        },
        {
          text: this.$t("message.uploadImageComponent.body.leftContainer.filter.documentType"),
          value: 'document_type'
        },
      ],
      orderBy: {
        text: this.$t("message.uploadImageComponent.body.leftContainer.filter.date"),
        value: 'creation_date'
      },
      initValue: {
        text: this.$t("message.uploadImageComponent.body.leftContainer.filter.date"),
        value: 'creation_date'
      }
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    isIndeterminate() {
      return this.selectedItems > 0 && this.selectedItems < this.visibleItems
    },
  },
  watch: {
    isIndeterminate(newVal) {
      if(newVal) {
        this.value = false
        this.keyCheckbox++
      } else {
        if (this.selectedItems === this.visibleItems) {
          this.value = true
          this.keyCheckbox++
        }
      }
    }
  },
  created() {
    let identity
    switch (this.getUser.pais) {
      case "AR":
        identity = "CUIL"
        break
      case "MX":
        identity = "RFC"
        break
      case "UY":
        identity = "Cédula"
        break
      case "PE":
        identity = "DNI"
        break
      case "CL":
        identity = "RUT"
        break
      case "CO":
        identity = "Cédula de Ciudadanía"
        break
      case "EC":
        identity = "Cédula de identidad"
        break
      case "BO":
        identity = "Cédula"
        break
      case "CW":
        identity = "Registration Number"
        break
      case "TT":
        identity = "Registration Number"
        break
      case "BB":
        identity = "Registration Number"
        break
      default:
        identity = "Identificador único"
        break
    }
    const index = _.findIndex(this.orderTypes, (e) => e.value === 'document_type',0);
    this.orderTypes.splice(index, 0, {text: identity, value: 'cuil'})

    this.asc = this.orderBy.value !== 'creation_date' ? true : false
    this.$emit('order-list', {
      type: this.asc ? 'asc' : 'desc',
      value: this.orderBy.value
    })
  },
  methods: {
    selectAll() {
      this.value = true
      this.keyCheckbox++
      this.$emit("select-all")
    },
    changeSelectAll(value) {
      if(value || this.isIndeterminate) {
        this.$emit('select-visible')
      }else{
        this.$emit('clear-all-selected')
      }
    },
    changeAscDesc() {
      this.asc = !this.asc
      this.$emit('order-list', {
        type: this.asc ? 'asc' : 'desc',
        value: this.orderBy.value
      })
    },
    changeOrderBy() {
      if (isEqual(this.initValue, this.orderBy)) return
      this.initValue = this.orderBy
      this.asc = this.orderBy.value !== 'creation_date'
      this.$emit('order-list', {
        type: this.asc ? 'asc' : 'desc',
        value: this.orderBy.value
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.bg-multiple-selection {
  background-color: #c4c4c4;
}
.zt-checkbox {
  margin-top: 0px !important;
}
.items-selected {
  font-size: 1rem;
}
.select-all-btn {
  font-size: 1.1rem;
  color: #254ff2;
}
::v-deep .zt-dropdown-item__content {
  font-family: Roboto;
}
</style>